// extracted by mini-css-extract-plugin
export default {"proTag":"pro_proTag__JG8cp","bbc":"pro_bbc__LMJBn","bbcCol":"pro_bbcCol__SHmLU","bbcSpan":"pro_bbcSpan__USCGT"};